import { render } from "./WarehouseCreate.vue?vue&type=template&id=7d5b5d4d&scoped=true&ts=true"
import script from "./WarehouseCreate.vue?vue&type=script&lang=ts"
export * from "./WarehouseCreate.vue?vue&type=script&lang=ts"

import "./WarehouseCreate.vue?vue&type=style&index=0&id=7d5b5d4d&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d5b5d4d"]])

export default __exports__